import React, { FunctionComponent } from 'react';
import { EducationalHistories, CareerHistories, CareerEmploymentType } from '../../../types/personShow';
import { PersonShowMainItem } from '../../molecules/personShowMainItem';

type Props = {
  mainTitle: string;
  isOneYearPassed: boolean;
  penIconImg: string;
  introduction: string;
  educationalHistories: EducationalHistories[];
  careerHistories: CareerHistories[];
  activity: string;
  slogan: string;
  interests: string[];
  skills: string[];
  favoriteBrands: string[];
  handleClick: (target: string, title: string) => void;
  onChangeClickTarget: (value: number) => void;
  isShow: boolean;
  isStudent: boolean;
  careerEmploymentTypes: CareerEmploymentType[];
};

export const Presentation: FunctionComponent<Props> = ({
  mainTitle,
  isOneYearPassed,
  penIconImg,
  introduction,
  educationalHistories,
  careerHistories,
  activity,
  slogan,
  interests,
  skills,
  favoriteBrands,
  handleClick,
  onChangeClickTarget,
  isShow,
  isStudent,
  careerEmploymentTypes,
}) => {
  const shouldDisplay = (value: any) => {
    if (value === '' || value === undefined || value.length === 0) {
      return isShow;
    }
    return true;
  };

  return (
    <>
      <h2 className="mainTitle">{mainTitle}</h2>

      {shouldDisplay(introduction) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="紹介文"
          value={introduction}
          type="normal"
          id="introduction"
          handleClick={handleClick}
          isShow={isShow}
          word="追加する"
        />
      )}

      {shouldDisplay(educationalHistories) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="学歴"
          array={educationalHistories}
          type="histories"
          id="educationalHistories"
          handleClick={handleClick}
          onChangeClickTarget={onChangeClickTarget}
          isShow={isShow}
          word="追加する"
          unCompleted={educationalHistories?.length < 1}
        />
      )}

      {!isOneYearPassed && shouldDisplay(careerHistories) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="職歴"
          array={careerHistories}
          type="histories"
          id="careerHistories"
          handleClick={handleClick}
          onChangeClickTarget={onChangeClickTarget}
          isShow={isShow}
          word="追加する"
          unCompleted={careerHistories?.length < 1}
          isStudent={isStudent}
          careerEmploymentTypes={careerEmploymentTypes}
        />
      )}

      {shouldDisplay(activity) && isStudent && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="在学中の活動"
          value={activity}
          type="normal"
          id="activity"
          handleClick={handleClick}
          isShow={isShow}
          word="追加する"
        />
      )}

      {shouldDisplay(slogan) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="挑戦したいこと"
          value={slogan}
          type="normal"
          id="slogan"
          handleClick={handleClick}
          isShow={isShow}
          word="追加する"
        />
      )}

      {shouldDisplay(interests) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="興味・関心"
          array={interests}
          type="skills"
          id="interests"
          handleClick={handleClick}
          isShow={isShow}
          word="追加する"
          unCompleted={interests?.length < 1}
        />
      )}

      {shouldDisplay(skills) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="スキル・特徴・資格"
          array={skills}
          type="skills"
          id="skills"
          handleClick={handleClick}
          isShow={isShow}
          word="追加する"
          unCompleted={skills?.length < 1}
        />
      )}

      {shouldDisplay(favoriteBrands) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="好きなブランド"
          array={favoriteBrands}
          type="brands"
          id="favoriteBrands"
          last={true}
          handleClick={handleClick}
          isShow={isShow}
          word="追加する"
          unCompleted={favoriteBrands?.length < 1}
        />
      )}
    </>
  );
};
